$.validator.addMethod(
  "regex",
  function(value, element, regexp) {
    var re = new RegExp(regexp);
    return this.optional(element) || re.test(value);
  },
  "Поле заполнено неверно"
);

class InteractiveForm {
  constructor(el, opts = {}) {
    this.$form = $(el);
    this.isCallTouch = this.$form.data('calltouch');

    let $form = this.$form;

    this.type = opts.type;

    $form.on('submit', function(e) {
      e.preventDefault();
    });

    if ($form.data("action")) {
      $form.prop("action", $form.data("action"));
    }

    let $phoneInputs = $form.find('[name="phone"], [type="tel"]');

    $phoneInputs.inputmask({
      mask: "+7 (999) 999 99 99",
      showMaskOnHover: false
    });

    $form.find('.input')
      .on('focus', (e) => {
        $(e.currentTarget).addClass('_focus');
      })
      .on('focusout', (e) => {
        if ($(e.currentTarget).val() == '') {
          $(e.currentTarget).removeClass('_focus');
        }
        else {
          $(e.currentTarget).addClass('_focus');
        }
      });

    $(document).on('click', (e) => {
      if ($(e.target).parent('.input').length === 0) {
        // alert('input')
        $form.find('.input').each((i, e) => {
          if ($(e).val() !== '') {
            $(e).addClass('_focus');
          }
        });
        // alert('focus')
      }
    });

    $form.find('[name="captcha"]').inputmask({
      mask: "99999",
      showMaskOnHover: false
    });

    let validatorOpts = {
      rules: {
        captcha: {
          required: true,
          regex: /\d\d\d\d\d/
        },
        email: {
          required: true,
          regex: /\S+@\S+\.\S+/
        },
      },
      errorElement: "em",
      onfocusout: (el, event) => {
        if ($(el).val() !== '') {
          $(el).valid();
        }
      },
      focusCleanup: false,
      submitHandler: opts.submitHandler || this.standartFormHandler, //(form)=>{}
      errorPlacement: ($errorLabel, $el) => {
        if ($el.closest('.action-page-form__row').length) {
          return true;
        }
        if ($el.attr("name") === "agree") {
          return true;
        } else {
          $errorLabel.addClass("Form_hint Form_hint-error");
          $el.parent().append($errorLabel);
          return true;
        }
      }
    };

    $phoneInputs.each((index, el) => {
      validatorOpts.rules[el.name] = {
        required: !!el.required,
        regex: /\+7\s\(\d\d\d\)\s\d\d\d\s\d\d\s\d\d/
      };
    });

    if (opts.validatorParams) {
      $.extend(true, validatorOpts, opts.validatorParams);
    }

    if (opts.successBlockMod) {
      $.extend(true, opts, { successBlockMod: "default" });
    }

    this.opts = opts;
    this.validator = $form.validate(validatorOpts);
  }

  standartFormHandler(form) {
    let $form = $(form);
    let isCallTouch = $(form).data('calltouch');

    // window.pagePreloader.show();


    let phone_val = $form.find("input[type=tel]").val();
    if (phone_val) {
      // console.log('phone_val', phone_val)
      phone_val = phone_val.replace(/[\s+-]/g, "");
    }

    const r = /\+7\d{10}/;
    // console.log('headerPhone', $('.Header__phone').attr('href'))
    // .match(r))
    //const headerPhone = $('.Header__phone').attr('href').replace('tel:', '');

    let dataToSend = $.extend(true, $form.serializeObject(), {
      Submit: 1,
      //headerPhone: headerPhone,
      url: window.location.href,
      'g-recaptcha-response': $form.find("textarea[name=g-recaptcha-response]").val(),
      // calltouch: data
    });
    console.log('dataToSend', dataToSend)
    $.ajax({
      url: form.action,
      type: form.method,
      data: dataToSend
    })
      .done(response => {
        let errorCode = parseInt(response.code);
        let formType = form.dataset.type;
        const gtmEvent = form.dataset.gtmEvents;
        $form.trigger('reset');
        if (gtmEvent && typeof gtag !== "undefined") {
          const data = $(form).data('gtm-events-info');
          gtag('event', gtmEvent, {
            'send_to': 'AW-608383498',
            'value': data.price,
            'items': [
              { 'id': data.id, 'google_business_vertical': 'real_estate' }
            ]
          }
          );
        }
        //$.fancybox.close();
        //const $successPopup = $('[data-success-popup]');

        /*$.fancybox.open($successPopup, {
          touch: false,
          toolbar: false,
          baseClass: "FormPopup",
          smallBtn: false,
          autoFocus: false,
          afterShow: function (instance) {
            const $container = instance.$refs.stage;
            $container.find('[data-close]').on('click', function () {
              instance.close();
            });
          }
        });*/


        $form.find('.input').removeClass('_focus');
        if (errorCode === 0) {
          //let successText;
          let $successContainer = $form.parent().find('[data-callme-success]');
          $form.parent().toggleClass('_success')
          $successContainer.html(response.success);
          /*switch (formType) {
            case 'callmePopup':
              $successContainer.html("");
              $successContainer.addClass('_success');
              successText =
                `<div class="Forms_tlt _success">${response.title}<small>${response.success}</small></div>
                <button data-fancybox-close class="Forms_btn Btn">Хорошо, спасибо</button>`;
              $successContainer.html(successText);
              $successContainer.show();
              break;
            case 'mortgagePopup':
              $successContainer.html("");
              $successContainer.addClass('_success');
              $successContainer.prev('.MortgagePopup_top').addClass('_success')
              successText =
                `<div class="Forms_tlt _success">${response.title}<small>${response.success}</small></div>
                <button data-fancybox-close class="Forms_btn Btn">Хорошо, спасибо</button>`;
              $successContainer.html(successText);
              $successContainer.show();
              break;
            case 'callme':
              $successContainer.parent().find('.CallMe_tlt').html(response.title);
              $successContainer.parent().find('.CallMe_subtlt').html(response.success);
              $successContainer.hide();
              break;
            case 'letter':
              const $letterPopup = $('[data-letter-popup]');
              $successContainer.html("");
              $successContainer.addClass('_success');
              successText =
                `<div class="Forms_tlt _success">${response.title}<small>${response.success}</small></div>
                <button data-fancybox-close class="Forms_btn Btn">Хорошо, спасибо</button>`;
              $successContainer.html(successText);
              $successContainer.show();
              $letterPopup.addClass('_success');
              break;
          }*/

        } else if (errorCode === 1) {
          let validator = $form.data("validator");
          $form
            .find('[name="captcha"]:first')
            .val("")
            .trigger("focus");

          validator.showErrors({
            captcha: response.error
          });
        } else {
          alert("Не удалось отправить форму! Попробуйте позже или обратитесть по телефону...");
        }
      })
      .always((/*response*/) => {
        // window.pagePreloader.hide();
      });

  }

  success(response) {

  }

  destroy() {
    this.validator.destroy();
    this.$form.find("input").inputmask("remove");
  }
}

